/**
 * RebookMovingFromCard — the workshop the customer is being moved OFF, shown at
 * the top of the rebook drawer with a "Current" chip (BON-146).
 *
 * Present for orientation, not decoration: a CSR judges whether a candidate date
 * is acceptable by how far it moves the customer, and that comparison needs the
 * date they are leaving on the same screen. The same workshop appears in the
 * calendar carrying the same "Current" wording.
 */
import { CalendarClock } from 'lucide-react';

import type { BookingWorkshop } from '../../api/bookingsV2';

import { formatPickerDate, formatPickerTime } from './shared/WorkshopPickerHelpers';

export interface RebookMovingFromCardProps {
  workshop: BookingWorkshop;
}

export function RebookMovingFromCard({ workshop }: RebookMovingFromCardProps) {
  const date = formatPickerDate(workshop.localStartDatetime);
  const time = formatPickerTime(workshop.localStartDatetime);
  return (
    <div className="flex items-center gap-3 rounded-lg border border-stone-200 bg-stone-50 px-3.5 py-3 dark:border-stone-700 dark:bg-stone-800/40">
      <CalendarClock size={16} className="flex-shrink-0 text-stone-500" />
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-bark-900 dark:text-stone-100">
          {workshop.name ?? 'Workshop'} &middot; {workshop.venue.name}
        </p>
        <p className="truncate text-xs text-stone-500 dark:text-stone-400">
          {date}
          {time ? ` · ${time}` : ''} &middot; {workshop.venue.city}, {workshop.venue.state}
        </p>
      </div>
      <span className="flex-shrink-0 rounded-full border border-stone-300 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-stone-500 dark:border-stone-600 dark:text-stone-400">
        Current
      </span>
    </div>
  );
}
